import { render } from "./Edit.vue?vue&type=template&id=6711908c"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/PurchaseOrders/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6711908c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6711908c', __exports__)) {
    console.log('reload')
    api.reload('6711908c', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=6711908c", () => {
    console.log('re-render')
    api.rerender('6711908c', render)
  })

}


export default __exports__